// Referral reward ladder, the same one the Referral Hub (/referralhub) uses:
// rewards are earned on the member's lifetime referral count, across every challenge.
export const REFERRAL_REWARDS = [
  { name: "stickers", needed: 1 },
  { name: "socks", needed: 5 },
  { name: "toque", needed: 10 },
  { name: "free entry", needed: 20 },
];

// All referrals the member has ever made: referrals/{uid}.totals is { raceName: { legName: count } }.
export function countAllReferrals(referralDoc) {
  const totals = referralDoc?.totals;
  if (!totals || typeof totals !== "object") return 0;
  return Object.values(totals).reduce((sum, legs) => {
    if (!legs || typeof legs !== "object") return sum;
    return sum + Object.values(legs).reduce((legSum, count) => legSum + (Number(count) || 0), 0);
  }, 0);
}

// Where the member is on the ladder: the last reward reached, the next one, and how many friends to go.
export function getReferralProgress(total) {
  const count = Math.max(0, Number(total) || 0);
  const earned = REFERRAL_REWARDS.filter((reward) => count >= reward.needed);
  const next = REFERRAL_REWARDS.find((reward) => count < reward.needed) || null;
  const previousNeeded = earned.length ? earned[earned.length - 1].needed : 0;
  return {
    count,
    earned: earned[earned.length - 1] || null,
    next,
    toGo: next ? next.needed - count : 0,
    // Share of the way from the last reward to the next one, for a small progress bar.
    percent: next ? Math.round(((count - previousNeeded) / (next.needed - previousNeeded)) * 100) : 100,
  };
}

const friends = (n) => `${n} friend${n === 1 ? "" : "s"}`;

// The goal line under the rewards picture. With no referrals yet it is the challenge's own line
// (e.g. "Just one friend gets you the Winter Warrior stickers."); otherwise it uses the member's real count.
export function referralGoalText(total, zeroText = "Just one friend gets you the stickers.") {
  const { count, earned, next, toGo } = getReferralProgress(total);
  if (count === 0) return zeroText;
  if (!next) return `You've already brought ${friends(count)} and unlocked every reward. Thank you!`;
  return `You've already brought ${friends(count)} and earned the ${earned.name}. ${toGo === 1 ? "Just 1 more friend gets" : `${toGo} more friends get`} you the ${next.name}.`;
}
